'use strict';

import SiteGlobal from './site-global.js';

import { onReady, setCookie } from './utils.js';

// Fix .forEach on nodelist for old browsers
if ( ! NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * Polyfill Element.matches().
 *
 * @see https://github.com/jonathantneal/closest/blob/master/src/index.js
 */
const ElementPrototype = window.Element.prototype;
if ( typeof ElementPrototype.matches !== 'function' ) {
	ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.webkitMatchesSelector || function matches( selector ) {
		const element = this;
		const elements = ( element.document || element.ownerDocument ).querySelectorAll( selector );
		let index = 0;
		while ( elements[ index ] && elements[ index ] !== element ) {
			++index;
		}
		return Boolean( elements[ index ] );
	};
}

/**
 * Polyfill Element.closest().
 *
 * @see https://github.com/jonathantneal/closest/blob/master/src/index.js
 */
if ( typeof ElementPrototype.closest !== 'function' ) {
	ElementPrototype.closest = function closest( selector ) {
		let element = this;
		while ( element && element.nodeType === 1 ) {
			if ( element.matches( selector ) ) {
				return element;
			}
			element = element.parentNode;
		}
		return null;
	};
}

// Ready
onReady( function() {
	// Init plugins
	SiteGlobal.init();

	// Main menu (dropdowns)
	SiteGlobal.bindEvent( 'click', '.menu-item-has-children > a, .c-menu__dropdown > .c-menu__item', function( event ) {
		event.preventDefault();
		const parent = this.closest( '.c-menu__dropdown, .menu-item-has-children' );
		parent.classList.toggle( 'c-menu__dropdown_active' );
	} );

	// Main menu (mobile)
	SiteGlobal.bindEvent( 'click', '.js-toggle-mobile-menu', function( event ) {
		event.preventDefault();
		document.body.classList.toggle( 'u-menu-open' );
		document.body.classList.toggle( 'u-scroll-lock' );
	} );

	// Main menu (mobile)
	SiteGlobal.bindEvent( 'click', '.js-close-user-menu', function( event ) {
		event.preventDefault();
		this.closest( '.c-menu__dropdown' ).classList.remove( 'c-menu__dropdown_active' );
	} );

	// Search form
	SiteGlobal.bindEvent( 'click', '.js-toggle-search-form', function( event ) {
		event.preventDefault();
		const form = document.getElementById( this.getAttribute( 'aria-controls' ) );
		const expanded = ( this.getAttribute( 'aria-expanded' ) === 'true' );
		form.hidden = expanded;
		this.setAttribute( 'aria-expanded', ! expanded );
		if ( ! expanded ) {
			form.querySelector( '#search_word' ).focus();
		}
	} );

	SiteGlobal.bindEvent( 'click', '.js-close-search-form', function( event ) {
		event.preventDefault();
		const form = document.getElementById( this.getAttribute( 'aria-controls' ) );
		const expanded = true;
		const toggle_button = document.querySelector( '.js-toggle-search-form' );
		form.hidden = expanded;
		toggle_button.setAttribute( 'aria-expanded', ! expanded );
		toggle_button.focus();
	} );

	// Close notification
	document.querySelectorAll( '.js-close-notification' ).forEach( function( element ) {
		element.addEventListener( 'click', function() {
			this.closest( '.c-notification' ).remove();
			// Hide the floating CTA for 7 days.
			setCookie( 'donation-cta-show-1', Math.round( new Date().getTime() / 1000 ) + ( 7 * 24 * 3600 ), 7 );
		} );
	} );
} );
